import { startMonitoring } from "./monitoring";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import { loadRuntimeConfig } from "./runtimeConfig";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";

// Monitoring is imported first so errors from the start of the page are held until Sentry is ready.
loadRuntimeConfig()
  .then((c) => startMonitoring({ dsn: c.sentryDsn, environment: c.environment, release: __APP_RELEASE__ }))
  .catch(() => startMonitoring({ dsn: "", environment: "" }));

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
